import api from './interceptor'

// 获取领券中心列表数据
export const getCouponCollectionList = params => {
  return api.get('/couponCenter/list', { params })
}

// 获取优惠券详情数据
export const getCouponDetail = params => {
  return api.get('/couponCenter/get', { params })
}

// 根据经销商获取当前优惠券统计数量
export const getPurchaseAmount = params => {
  return api.get('/couponCenter/purchaseAmount', { params })
}

// 领取优惠券
export const getPurchase = params => {
  return api.post('/couponCenter/purchase', params)
}

// 获取我的领券列表数据
export const getMyCouponList = params => {
  return api.get('/rightCoupon/myCouponList', { params })
}

// 获取我的领券详情数据
export const getMyCouponDetail = params => {
  return api.get('/rightCoupon/myCouponDetail', { params })
}
